import React, { Suspense, lazy } from 'react';
import { Link, Redirect, Route } from 'react-router-dom';
import { App, AppState } from "@capacitor/app"
import { Geolocation } from "@capacitor/geolocation"
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from "@capacitor/push-notifications";
import {
  IonAlert,
  IonApp,
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonModal,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs, IonTitle, IonToast, IonToolbar, isPlatform, setupIonicReact, IonSpinner, IonGrid, IonRow, IonCol, IonText
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Api from "./services/Api";
import WebSocketClient from "./services/WebSocketClient";

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Theme variables */

import './theme/variables.css';
import './theme/font.css';
import './theme/custom.scss';
import './theme/tailwind.scss';
import ReLogin from "./pages/ReLogin";
import ShareWalk from "./pages/ShareWalk";
import Testing from "./pages/Testing";
import Feedback from "./pages/Feedback";
import AppUrlListener from "./components/AppUrlListener";

/* redux */
import {connect} from 'react-redux';
import { getLocation, getUser, removeProBackend } from './redux/actions/logInActions'
import { getMyWalks } from './redux/actions/walkActions'
import { getErrors } from './redux/actions/errorAction'
import { getFriends } from './redux/actions/friendActions'
import { openChat, closeChat } from './redux/actions/chatActions'
import { openAlert } from './redux/actions/alertActions'
import { openNoticeAction } from './redux/actions/noticeAction'
import { openProfile, closeProfile } from './redux/actions/profileActions'
import { openTalk, closeTalk } from './redux/actions/talkAction'
import { setPageAction } from './redux/actions/pageListenerActions'
import { setUnreadAction } from './redux/actions/messageAction'
import { addPro } from './redux/actions/logInActions'

import LogIn from './pages/LogIn';
import history from './helpers/history';
import FirebaseProvider from './services/FirebaseAnalytics'
import ProtectedRoute from './pages/ProtectedRoute';
import MyPage from './pages/MyPage';
import { MenuSettings } from './components/MenuSettings';
import TalkClosed from './pages/talk/TalkClosed';
import Error from './components/Error';
import { goToPage } from './helpers/app_actions';
import { arrowForward, chatboxOutline, closeOutline, ellipse } from 'ionicons/icons';
// import PurchasePage from './pages/Purchase/PurchasePage';
import TalkPage from './pages/TalkPage';
import SharePrivateWalk from './pages/SharePrivateWalk/SharePrivateWalk';
// import MyFriendslist from './components/MyFriendslist';
// import Rooms from './pages/DjarvTest/Rooms';
// import Conversations from './pages/DjarvTest/Conversations';
// import Friends from './pages/DjarvTest/Friends';
// import Walks from './pages/DjarvTest/Walks';
// import Purchases from './pages/DjarvTest/Purchases';
// import Language from './pages/DjarvTest/Language';
// import Menu from './pages/DjarvTest/Menu';
import { WalkModal } from './components/Walk/WalkModal';
import { hasProAuth } from './helpers/auth_helper'
import { MultipleWalksPage } from './pages/Home/MultipleWalksPage';
import ToolTypeRandom from './pages/Tools/ToolTypeRandom';
// import StepCounter  from './pages/StepCounter/StepCounter'
import {CreatePage} from './pages/Create/CreatePage'
import TeamMembers from './pages/Team/TeamMembers';
import MyNetworks from './pages/networks/MyNetworks';
import ExploreNetworks from './pages/networks/ExploreNetworks';
import CreateChallenge from './pages/StepCounter/CreateChallenge';
import ChallengeStatistic from './pages/StepCounter/ChallengeStatistic';
import ChallengePage from './pages/StepCounter/ChallengePage';
import Statistic from './pages/Statistic/Statistic';
import Courses from './pages/Courses/Courses';
import { Course } from './pages/Courses/Course';
import { Lesson } from './pages/Courses/Lesson';
import Conversations from './pages/Chat/Conversations';
import ChallengeLeaderboard from './pages/StepCounter/ChallengeLeaderboard';
import Rooms from './pages/DjarvTest/Rooms';
import { Menu } from '@material-ui/core';
import { SearchFriends } from './pages/SearchFriends';
import TimeBox from './components/TimeBox/TimeBox';
import { checkStepcounterEnabled, getStepSettings, resumeApp } from './helpers/step_helper';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions';
const MyFriendslist = lazy(() => import('./components/MyFriendslist'))
const Notes = lazy(() => import('./components/Notes'))
const ChatPage = lazy(() => import('./pages/ChatPage'))
const PurchasePage = lazy(() => import('./pages/Purchase/PurchasePage'))
// const CreatePage = lazy(() => import('./pages/Create/CreatePage'))
const HomePage = lazy(() => import('./pages/HomePage'))
const StepCounter = lazy(() => import('./pages/StepCounter/StepCounter'))
const Walk = lazy(() => import('./pages/Walk'))
const ProductPage = lazy(() => import('./pages/Purchase/ProductPage'))
const GetTeams = lazy(() => import('./pages/Team/GetTeams'))
const CreateSuccessPage = lazy(() => import('./pages/Create/CreateSuccessPage'))
const CreateWalk = lazy(() => import('./pages/CreateWalk'))
const SharedProfilePage = lazy(() => import('./pages/Profile/SharedProfilePage'))
const JoinTeam = lazy(() => import("./pages/Team/JoinTeam"))
const FindTeam = lazy(() => import('./pages/Team/FindTeam'))
const Team = lazy(() => import('./pages/Team/Team'))
const Tools = lazy(() => import('./pages/Tools/Tools'))
const PurchaseDone = lazy(() => import('./pages/Purchase/PurchaseDone'))
const MyPurchases = lazy(() => import('./pages/Settings/MyPurchases'))
const ChatReport = lazy(() => import('./pages/Chat/ChatReport'))
const MyWalkPage = lazy(() => import('./pages/MyWalkPage'))
const FaqTipsModal = lazy(() => import('./pages/Create/FaqTipsModal'))
const BlockedPeople = lazy(() => import('./pages/Settings/BlockedPeople'))
const PersonalSettings = lazy(() => import('./pages/Settings/PersonalSettings'))
window.store = window.CdvPurchase.store

const Store: CdvPurchase.Store = window.store 

interface ComponentProps {
  openProfile: any
  closeProfile: any
  openNoticeAction: any
  notice: any
  openAlert: any
  alert: any
  closeChat: any
  openChat: any
  openTalk: any
  closeTalk: any
  getFriends: any
  getLocation: any
  getMyWalks: any
  location: any
  getErrors: any
  myWalksURL: string
  getUser: any
  user: any
  loggedIn: boolean
  disabled: boolean
  setPageAction: Function
  setUnreadAction: Function
  unread: {unread: boolean}
  addPro: Function
  removeProBackend: Function
}

interface ComponentState {
  loading: boolean
  showUnreadToast: boolean;
  showUnreadToastLink: boolean;
  toastLink: string;
  toastMessage: string;
  loggedIn: boolean;
  redirect: string;
  reLogin: boolean;
  page: string
  action: string
  // locationState: any
}

setupIonicReact()

class WTApp extends React.Component<ComponentProps, ComponentState>  {

  private api = Api.getInstance();
  private webSocketClient = WebSocketClient.getInstance();
  private hasLoggedIn: boolean;
  private fba = FirebaseProvider.getInstance()

  constructor(props: ComponentProps) {
    super(props)
    this.state = {
      loading: true,
      showUnreadToast: false,
      showUnreadToastLink: false,
      toastMessage: '',
      toastLink: '',
      loggedIn: false,
      redirect: '',
      reLogin: false,
      page: window.location.pathname, 
      action: '',
      // locationState: 0
    };
    this.hasLoggedIn = false;
  }

  componentDidMount() {
    this.activeListener()
    this.historyListener()
    this.getGpsLocation()
    this.fetchWalks()
    this.pushListener();
    this.webSocketClient.eventEl.addEventListener('session', this.sessionListener);
    this.loginHandler(this.api.loggedIn);
    this.pageListener()
    // this.addRemoveFooter()

    if (isPlatform('capacitor')) {
      App.addListener('appStateChange', (state: AppState) => {
        // state.isActive contains the active state
        if (state.isActive) {
          this.webSocketClient.reOpenSocket();
          setTimeout(() => {
            this.webSocketClient.sendEvent('resumeApp', 'active')
          }, 300)
        } else {
          this.webSocketClient.close();
        }
      });

      if(isPlatform('android')) {
        AndroidPermissions.checkPermission("android.permission.ACTIVITY_RECOGNITION").then(res => {
          if(res.hasPermission) {
            getStepSettings()
            this.webSocketClient.eventEl.addEventListener('resumeApp', resumeApp())
          } else {
            // handle ios
            checkStepcounterEnabled()
          }
        })
      }
        
    } else {
      // console.log('--- not capacitor');
    }

    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })

    // if(!isPlatform('capacitor') && window.innerWidth <= 800) {
    //   let tabBar: any = document.getElementById('myTabBar')
    //   tabBar.style.position = 'fixed'
    //   tabBar.style.bottom = '157px'
    //   tabBar.style.height = '190px'
    // } 

    if(isPlatform('mobileweb')) {
      let tabBar: any = document.getElementById('myTabBar')

      tabBar.style.position = 'fixed'
      tabBar.style.bottom = '57px'
      tabBar.style.height = '140px'
    }
    // this.getStart()
  }

  componentWillUnmount(): void {
    if (isPlatform('capacitor')) {
      this.webSocketClient.eventEl.removeEventListener('resumeApp', resumeApp());
    }
  }

  activeListener = () => {
    document.addEventListener("pause", this.onPause, false);
    document.addEventListener('resume', this.onResume, false)
  }

  onPause = () => {
      // Handle the pause event
    // console.log('PAUSED')
  }

  onResume = () => {
    // Handle the resume event  
    Store.update()
  }
  
  componentDidUpdate = () => {
    // this.addRemoveFooter()
    this.chatOpen()
    this.profileOpen()
    this.talkOpen()
  }

  pageListener = () => {
    if(document.location.pathname.includes('/chat')) {
      this.chatOpen()
    }

    if(document.location.pathname.includes('/user/profile/')) {
      this.profileOpen()
    }

    if(document.location.pathname.includes('/djarvtest/talk/')) {
      this.talkOpen()
    }

    history.listen((location, action) => {
      this.setState({
        page: location.pathname,
        action: action
      })

      this.props.setPageAction({
        currentLocation: location.pathname
      })
    });
  }

  talkOpen = () => {
    if(this.state.page.includes('/talk/me/')) {
        this.props.openTalk()
        // console.log('opening')
    } else {
      this.props.closeTalk()
    }
  }

  chatOpen = () => {
    if(this.state.page.includes('/walk/chat/')) {
      const regex = /[0-9]+/g;
      const personId = this.state.page.match(regex)
      if(personId !== null) {
        this.props.openChat(parseInt(personId[0]))
      }
        // console.log('closing')
    } else {
      this.props.closeChat(0)
    }
  }

  profileOpen = () => {
    if(this.state.page.includes('/walk/user/profile')) {
        this.props.openProfile()
    } else {
      this.props.closeProfile()
    }
  }

  // addRemoveFooter = () => {
  //   const remove: Array<string> = ['/settings', '/chat', '/user/profile/, /walk/shop/success']
  //   if(remove.includes(this.state.page)) {
  //     removeFooter()
  //   } else {
  //     addFooter()
  //   }
  // }

  private fetchWalks = () => {
    this.api.get('find_walks').then(result => {
     result.json()
     .then(res =>{ 
       this.props.getMyWalks(res)
      })
    })
  }

  private getMyWalks = () => {
    if(this.props.loggedIn) {
      this.api.sess_get('my_walks').then(res => {
        this.props.getMyWalks(res)
      }).catch((error_status: any) => {
        this.webSocketClient.sendEvent('session', { 
          type: 'apiError', 
          status: error_status 
        })
      })
    }
  }

  getGpsLocation = () => {
    Geolocation.getCurrentPosition()
     .then((position: any) => {
       return {
         lat: position.coords.latitude,
         lng: position.coords.longitude
       }
     })
     .then((position: any) => this.props.getLocation(position))
     .catch((error: Error) => this.props.getErrors(error))
  }

  getUserData = () => {
    this.api.get('settings').then(res => {
      res.json().then(data => { 
        this.props.getUser(data)
        this.getMyWalks()
        // if(data.lastProExpires) {
        //   checkIfProHasExpired(data.lastProExpires)
        // }
        hasProAuth(data.WTTeams, data.lastProExpires, data.WTTeamsPurchaseId).then(res => {
          this.props.addPro(res)
        }).then(res => this.setState({ ...this.state, loading: false }))
      })
    }).then(res => {
      // console.log('now')
      // if(this.api.verification.appMessage !== null) {
      //   console.log('open')
      //   this.props.openNoticeAction(true)
      // }
    })
    this.checkMessages()
    this.props.getFriends()
  }

  checkMessages = () => {
    this.api.get('conversations').then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          if(data.conversations.find((o: any) => o.unreadMessages === true)) {
            this.props.setUnreadAction(true)
          } else {
            this.props.setUnreadAction(false)
          }
        }
      })
    })
  }

  private loginHandler = (loggedIn: boolean) => {
    this.setState({
      loggedIn: loggedIn
    });

    if (loggedIn) {
      this.api.getProfile().then(res => {
        if(res !== null) {
            this.props.openNoticeAction(true)
        }
      });
      this.getUserData()
      this.webSocketClient.eventEl.addEventListener('unread', this.unreadListener);
      this.webSocketClient.eventEl.addEventListener('talk', this.talkListener);
      // Register with Apple / Google to receive push via APNS/FCM
      if (isPlatform('capacitor')) {
        if (isPlatform('ios')) {
          // console.log('Requesting permission from ios device?');
          PushNotifications.requestPermissions().then((npr: any) => {
            // console.log(npr);
            PushNotifications.register();
          })
        } else {
          PushNotifications.register();
        }
      }
      // this.backgroundStuff.syncSteps();

      this.hasLoggedIn = true;

      this.setState({ 
        reLogin: false 
      });
    }
  }

  private sessionListener = (e: CustomEvent) => {
    const message = e.detail.message;

    if (message.type === 'login') {
      if (message.status === 'ok') {
        // console.log('loginHandler');
        this.loginHandler(true);
      }
    } else if (message.type === 'logout') {
      this.setState({
        loggedIn: false
      });

      this.webSocketClient.detachSocket();
      this.api.get('logout').then((result) => {
        if (result.ok) {
          this.api.logOut();
          // console.log('api.logout()');
        } else {
          // console.log('Failed logging out');
        }
        this.webSocketClient.eventEl.removeEventListener('unread', this.unreadListener);
        // this.goTo('/walk/home');
        window.location.href = "/walk/home"
        // console.log('goTo /walk/home');
      });
    } else if (message.type === 'apiError') {
      if (message.status === 403) {
        this.setState({reLogin: true});
      } else {
        // console.log(message.status);
      }
    } else {
      // console.log('Unhandled message: ', message);
    }
  }

  private pushListener = () => {
    if (!isPlatform('capacitor')) {
      return;
    }

    // On succcess, we should be able to receive notifications
    // console.log('------ addListener registration')
    PushNotifications.addListener('registration',
      (token: Token) => {
      // console.log('--- got registration callback with token ' + token.value)
        const platform = (isPlatform('ios')) ? 'ios' : (isPlatform('android')) ? 'android' : 'unknown';
        this.api.post('register_push_key', {'key': token.value, 'platform': platform}).then(
          apiData => console.log(apiData),
          error => console.error(error)
        )
      }
    )

    // Some issue with your setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        alert('Error on registration: ' + JSON.stringify(error))
      }
    )

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        // alert('Push received: ' + JSON.stringify(notification.data.link));
        let msg = notification.title + '\n' + notification.body;
        let link: any;
        if (notification.data.link2) {
          link = notification.data.link2
        } else if (notification.data.link) {
          link = notification.data.link;
        }
        if (link) {
          this.setState({
            toastMessage: msg,
            toastLink: link,
            showUnreadToastLink: true,
          })
        } else {
          this.setState({
            toastMessage: msg,
            showUnreadToast: true,
          });
        }

      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        let link: any;
        if (notification.notification.data.link2) {
          link = notification.notification.data.link2;
        } else if (notification.notification.data.link) {
          link = notification.notification.data.link;
        }
        if (link) {
          setTimeout(() => {
            this.goTo(link);
            // console.log('Went to to ' + link);
          }, 1000);
        }
      });
  }

  private unreadListener = (e: CustomEvent) => {
    let link: any;
    if (e.detail.message.link2) {
      link = e.detail.message.link2;
    } else if (e.detail.message.link) {
      link = e.detail.message.link;
    }
    if (link) {
      this.setState({
        toastMessage: e.detail.message.message,
        toastLink: link,
        showUnreadToastLink: true,
      })
    } else {
      this.setState({
        toastMessage: e.detail.message.message,
        showUnreadToast: true,
      });
    }
  }

  private talkListener = (e: CustomEvent) => {
    let link: any;
    link = '/walk/home'

    this.setState({
      toastMessage: e.detail.message.message,
      toastLink: link,
      showUnreadToastLink: true,
    })
  }

  private goTo = (url: string) => {
    this.setState({
      redirect: url
    });
    const link = document.getElementById('redirectId');
    if (link) {
      link.click();
    }
  }

  logIn = () => {
    this.setState({
      loggedIn: true
    });
  }

  authenticated = () => {
    const auth = ''
    try{
      if(auth) {
        return true;
      } else {
        return false;
      }
    }
    catch (e) {
     return false   
    }
  }

  historyListener = () => {
    history.listen(location => {
      if(window.location.pathname.includes('/walk/walk/')){
        if(this.props.loggedIn){
          this.checkAllowed()
        }
      }
    })
  }

  checkAllowed = () => {
    let allowed = false 
    
    let walkId = window.location.pathname.match(/[0-9]*$/g)
    if(walkId !== null) {
    this.api.get('walk/' + walkId[0] ).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          // console.log('getting data')
          if(data.walk.teamId === null) {
            allowed = true
          } else {
            this.props.user.teams.some((team: any) => {
              if(team.teamId === data.walk.teamId) {
                return allowed = true
              } else {
                return allowed
              }
            })
          }
        }
      })
    }) }
    return allowed
  }

  checkAuthenticated = () => this.props.loggedIn

  changeLanguage = (lang: string) => {
    if (this.api.setLanguage(lang)) {
      document.location.reload();
    } else {
      alert('Could not change to ' + lang)
    }
  }

  render() {
    if (this.state.reLogin) {
      return (
        <ReLogin />
      )
    }
    return (
      <IonApp>
        {/* <IonLoading  
          cssClass="loadingScreen"
          message="Loading..."
          showBackdrop 
          isOpen={this.state.loading} 
          duration={4000} 
          onDidDismiss={() => this.setState({loading: false})}
          /> */}
        <MenuSettings />
        <WalkModal />
        <IonAlert 
          isOpen={this.props.alert.isOpen}
          onDidDismiss={() => this.props.openAlert({
            message: '',
            header: ''
          })}
          cssClass='alert-window'
          header={this.props.alert.header}
          message={this.props.alert.message}
          buttons={this.props.alert.link === '' ? [{
            text: this.api.tr('close'),
            role: 'remove',
            // className: 'secondary',
          }] : [{
            text: this.api.tr('close'),
            role: 'remove',
            // className: 'secondary',
          },{
            text:  this.props.alert.linkText,
            // className: 'secondary',
            handler: () => {
              goToPage(this.props.alert.link)
            }
          }]}/>
        <IonModal 
          className="p-4"
          isOpen={this.props.notice.isOpen}>
            {this.api.verification.appMessage !== null ? 
            <>
              <IonHeader class="modalHeader" slot="fixed">
                <IonToolbar>
                  <IonButton 
                    onClick={() => this.props.openNoticeAction()} 
                    className="modalButton"  
                    slot="end" 
                    fill="clear">
                    <IonIcon 
                      icon={closeOutline} 
                      color="dark"
                      size="large"/>
                  </IonButton>
                  <IonTitle>{this.api.verification.appMessage.date} - {this.api.verification.appMessage.title}</IonTitle> 
                </IonToolbar>
              </IonHeader>
              <IonContent>
                {this.api.verification.appMessage.texts.map((paragraph: string, key:any) => (
                  <p key={key} className="p-4">{paragraph}</p>
                ))}
                <IonButton  
                  class="m-2"
                  fill="solid"
                  expand="block"
                  onClick={() => goToPage(this.api.verification.appMessage.link)}>
                  {this.api.verification.appMessage.linkText}</IonButton>
              </IonContent>
            </>
            : null}
        </IonModal>
        <IonToast
          isOpen={this.state.showUnreadToast}
          onDidDismiss={() => this.setState({showUnreadToast: false})}
          message={this.state.toastMessage}
          color="primary"
          position="top"
          buttons={[
            {
              text: this.api.tr('close'),
              role: 'cancel',
            }
          ]}
          duration={0} />
        <IonToast
          isOpen={this.state.showUnreadToastLink}
          onDidDismiss={() => this.setState({showUnreadToastLink: false, toastLink: ''})}
          message={this.state.toastMessage}
          color="primary"
          position="top"
          buttons={[
            {
              text: 'Läs',
              handler: () => {
                this.goTo(this.state.toastLink);
              }
            },
            {
              text: this.api.tr('close'),
              role: 'cancel',
            }
          ]}
          duration={0} />
        <Suspense fallback={<IonSpinner/>}>
        <IonReactRouter history={history} >
          {/* <CurrentWalk/> */}
          <AppUrlListener/>
          <Link to={this.state.redirect} id="redirectId" />
          {isPlatform('desktop' || 'mobileweb') ? 
          <IonHeader className="ion-no-border p-2">
            <IonGrid>
              <IonRow className="flex items-center">
                <IonCol className="flex items-center">
                  <a href="https://www.walkingtalkingacademy.com/" target="_blank" className="flex items-center">
                    <IonText color="primary" className="flex items-center">
                      Go to Walking Talking Academy
                      <IonIcon icon={arrowForward}/>
                    </IonText>
                  </a>
                </IonCol>
                <IonCol className="flex justify-end items-center">
                  { this.props.user.WTTeams ? null : 
                    <IonButton 
                      color="darkblue"
                      size="small" 
                      onClick={() => goToPage('/walk/getteams')}>Upgrade to Pro</IonButton>
                  }
                  { this.api.lang === 'sv' ? 
                    <IonButton 
                      fill="clear"
                      onClick={() => this.changeLanguage('en')}>
                      <img src="assets/icon/gb.svg" alt="british flag" width="35" height="23"/> 
                    </IonButton>
                    :
                    <IonButton
                      fill="clear"
                      onClick={() => this.changeLanguage('sv')}>
                      <img src="assets/icon/se.svg" alt="swedish flag" width="35" height="23"/>
                    </IonButton>
                  }
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonHeader>: null}
          <IonContent>
          <IonTabs>
            <IonRouterOutlet id="main">
              <ProtectedRoute
                exact
                path="/walk/home" 
                component={HomePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <Route path="/walk/login" component={LogIn} exact={true}/>
              <ProtectedRoute
                exact
                path="/walk/home/walks" 
                component={MultipleWalksPage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/createwalk/:walkId"
                component={CreateWalk}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/create"
                component={CreatePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/copy"
                component={CreatePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/time"
                component={CreatePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/success"
                component={CreateSuccessPage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/edit/:walkId"
                component={CreatePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/> 
              <ProtectedRoute
                exact
                path="/walk/feedback"
                component={Feedback}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/faq"
                component={FaqTipsModal}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/walk/:walkId"
                component={Walk}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/sharewalk/:walkId"
                component={ShareWalk}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <Route path="/walk/testing" component={Testing} exact={true}/>
              <Route path="/walk/" render={() => <Redirect to="/walk/mypage/walks"/>} exact={true}/>
              <Route path="/" render={() => <Redirect to="/walk/mypage/walks"/>} exact={true}/>
              <Route path="/walk/mypage" render={() => <Redirect to="/walk/mypage/walks"/>} exact={true}/>
              <Route 
                path="/walk/share/privatewalk/:walkId" 
                component={SharePrivateWalk} 
                // isAuthenticated={this.props.loggedIn}
                exact /> 
              <ProtectedRoute 
                exact
                path="/walk/mypage/:pageSegment" 
                component={MyPage} 
                isAuthenticated={this.props.loggedIn}
                isDisabled= {this.props.disabled}/>
              <ProtectedRoute 
                exact
                path="/walk/friends" 
                component={MyFriendslist} 
                isAuthenticated={this.props.loggedIn}
                isDisabled= {this.props.disabled}/>
              <ProtectedRoute 
                exact
                path="/walk/friends/search" 
                component={SearchFriends} 
                isAuthenticated={this.props.loggedIn}
                isDisabled= {this.props.disabled}/>
              <Route path="/walk/error" component={Error} />
              <Route path="/walk/djarvtest/steps" component={StepCounter} exact={true}/>
              <Route path="/walk/djarvtest/rooms" component={Rooms} exact={true}/>
              <Route path="/walk/djarvtest/conversations" component={Conversations} exact={true}/>
              {/* <Route path="/walk/djarvtest/friends" component={Friends} exact={true}/>
              <Route path="/walk/djarvtest/walks" component={Walks} exact={true}/>
              <Route path="/walk/djarvtest/purchases" component={Purchases} exact={true}/>
              <Route path="/walk/djarvtest/language" component={Language} exact={true}/>*/}
              <Route path="/walk/djarvtest" component={Menu} exact={true}/> 
              <Route
                path="/walk/djarvtest/talk/:who/:name/:meetingKey"
                component={TalkPage}
                exact={true}
              />
              <Route
                path="/walk/talk/:who/:name/:meetingKey"
                component={TalkPage}
                exact={true}
              />
              <Route
                path="/walk/external_talk/:who/:name/:meetingKey/:externalId"
                component={TalkPage}
                exact={true}
              />
              <Route
                path="/walk/external_talk_closed/:who/:name/:meetingKey/:externalId"
                component={TalkClosed}
                exact={true}
              />
              <Route
                exact
                path="/walk/user/profile/:userId"
                component={SharedProfilePage}/>
              <Route 
                exact 
                path="/walk/enter/:type" 
                component={ReLogin}/>
              <ProtectedRoute
                exact
                path="/walk/settings"
                component={PersonalSettings}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/settings/purchases"
                component={MyPurchases}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/getteams"
                component={GetTeams}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/join/:teamKey"
                component={JoinTeam}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/teams"
                component={FindTeam}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/team/:teamKey"
                component={Team}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/team/:teamKey/members"
                component={TeamMembers}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/networks"
                component={MyNetworks}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/networks/explore"
                component={ExploreNetworks}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/blocked"
                component={BlockedPeople}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/report/:personId/:messageId"
                component={ChatReport}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/chat/:userId"
                component={ChatPage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/notes/:walkId"
                component={Notes}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/stepcounter"
                component={StepCounter}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/profile/walks"
                component={MyWalkPage}
                isAuthenticated={this.props.loggedIn}                                                                     
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/statistic"
                component={Statistic}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/challenges"
                component={ChallengePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/challenges/:id"
                component={ChallengeStatistic}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/leaderboard"
                component={ChallengeLeaderboard}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/statistics/challenge/create"
                component={CreateChallenge}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/shop"
                component={PurchasePage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/shop/product/:productId"
                component={ProductPage}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/shop/:type"
                component={PurchaseDone}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              {/* <ProtectedRoute
                exact
                path="/walk/tools"
                component={Tools}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/tools/random"
                component={ToolTypeRandom}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/> */}
              {/* <ProtectedRoute
                exact
                path="/walk/courses"
                component={Courses}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/> */}
              {/* <ProtectedRoute
                exact
                path="/walk/courses/:id"
                component={Course}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              <ProtectedRoute
                exact
                path="/walk/courses/:id/:topic/:lesson"
                component={Lesson}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/> */}
              <ProtectedRoute
                exact
                path="/walk/conversations"
                component={Conversations}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/>
              {/* <ProtectedRoute
                exact
                path="/walk/timebox"
                component={TimeBox}
                isAuthenticated={this.props.loggedIn}
                isDisabled={this.props.disabled}/> */}
            </IonRouterOutlet>
            <IonTabBar 
              color={isPlatform('desktop') ? 'light' : undefined}
              slot={isPlatform('desktop') ? 'top' : 'bottom'} 
              class="safe_padding_bottom tabBar" 
              id="myTabBar">
              <IonTabButton tab="tab1" href="/walk/home" className="tabBarButton tab1">
                <IonIcon icon="assets/icon/find.svg" className="mt-2"/>
                <IonLabel>{this.api.tr('find_walks')}</IonLabel>
              </IonTabButton>
              <IonTabButton tab="tab2" href="/walk/create" className="tabBarButton tab2">
                <IonIcon icon="assets/icon/plus_button.svg" className="mt-2"/>
                <IonLabel>{this.api.tr('create_walk')}</IonLabel>
              </IonTabButton>
              <IonTabButton tab="tab4" href="/walk/mypage/walks" className="tabBarButton tab4">
                <IonIcon icon="assets/icon/walks.svg" className="mt-2"/>
                <IonLabel>
                  {this.api.tr('my_page')}
                </IonLabel>
              </IonTabButton>
              <IonTabButton tab="tab5" href="/walk/conversations" className="tabBarButton tab5">
                <IonIcon icon={chatboxOutline} className="mt-2"/>
                <IonLabel>
                {this.api.tr('chat_page')}
                  { this.props.unread.unread === true ? <IonIcon icon={ellipse} color="primary"/> : null }
                </IonLabel>
              </IonTabButton>
            </IonTabBar>
          </IonTabs> 
          </IonContent>
        </IonReactRouter>
        </Suspense>
      </IonApp>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    location: state.logIn.position,
    myWalksURL: state.logIn.myWalksURL,
    user: state.logIn.user,
    loggedIn: state.logIn.loggedIn,
    disabled: state.logIn.user.person.disabled,
    alert: state.alert,
    notice: state.notice,
    unread: state.unread
  }
}

const mapDispatchToProps = {
  getLocation,
  getMyWalks,
  getErrors,
  getUser,
  getFriends,
  openChat,
  closeChat,
  openAlert,
  openNoticeAction,
  openProfile,
  closeProfile,
  openTalk,
  closeTalk,
  setPageAction,
  setUnreadAction,
  addPro,
  removeProBackend
}

export default connect(mapStateToProps, mapDispatchToProps)(WTApp)
